import {FC} from "react";
import './styles.css';

interface BodyProps {
}

const Body: FC<BodyProps> = ({ text }) => {  {
    return (
        <div className='body'>
            Coming Soon
        </div>
    )
}}

export default Body;